import { Outlet, useLoaderData } from "@remix-run/react";
import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import PageWithNavigation from "~/components/PageWithNavigation";
import { getAuthenticatedUser } from "~/services/auth.server";

export async function loader({ request }: LoaderFunctionArgs) {
  const countryCodeHeader = request.headers.get("CF-IPCountry") || "US";
  const url = new URL(request.url);
  const user = await getAuthenticatedUser(request);

  if (url.pathname === "/terms-and-conditions") {
    return redirect(`/terms-and-conditions/${countryCodeHeader}`);
  }
  return json({ user });
}

export default function TermsAndConditions() {
  const { user } = useLoaderData<typeof loader>();
  return (
    <PageWithNavigation user={user}>
      <Outlet />
    </PageWithNavigation>
  );
}
